import { toast } from "sonner";

export const formatCurrency = (
	locale?: string,
	currency?: string,
	amount?: number,
): string => {
	if (amount === undefined || amount === null || Number.isNaN(amount)) {
		return "Invalid amount";
	}

	if (!locale || !currency) {
		return `${amount}`;
	}

	try {
		return new Intl.NumberFormat(locale, {
			style: "currency",
			currency: currency,
		}).format(amount);
	} catch (err) {
		toast.error(`${err}`);
		return "Invalid country or currency";
	}
};
